/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import SocialSSO from 'bundles/authentication/shared/components/authentication-modal/SocialSSO';
import type SSOError from 'bundles/authentication/shared/components/authentication-modal/SocialSSO/SSOError';
import TrackedDiv from 'bundles/page/components/TrackedDiv';

import _t from 'i18n!nls/authentication';

type Props = {
  trackingName?: string;
  onSSOError: (error: SSOError) => void;
  onSSOSuccess: (isRegistration: boolean) => void;
};

const styles = {
  root: css`
    display: grid;
    grid-gap: 32px;
    grid-template-columns: 1fr;
    margin: 0 auto;
    padding: 32px 16px;
    max-width: 396px;

    @media (max-width: 600px) {
      padding: 0 16px;
      margin-top: 32px;
    }
  `,
  title: css`
    color: var(--cds-color-neutral-primary);
    font-family: 'Open Sans', sans-serif;
    font-size: 24px;
    line-height: 30px;
    text-align: center;
    font-weight: bold;

    @media (min-width: 600px) {
      font-size: 34px;
      line-height: 42px;
    }
  `,
  terms: css`
    color: var(--cds-color-grey-600);
    font-size: 12px;
    line-height: 20px;
    margin: 16px 0 0;
    padding: 0 32px;
    text-align: center;

    &:first-of-type {
      margin: 0;
    }

    &:nth-of-type(n) a {
      color: inherit;
      text-decoration: underline;
    }
  `,
};

const SSO = ({ onSSOError, onSSOSuccess, trackingName = 'sso_modal' }: Props) => (
  <TrackedDiv withVisibilityTracking trackingName={trackingName} css={styles.root}>
    <header>
      <h1 css={styles.title}>{_t('Sign up and enroll')}</h1>
    </header>
    <SocialSSO onError={onSSOError} onSuccess={onSSOSuccess} services={['google', 'facebook']} />
    <p css={styles.terms}>
      <FormattedMessage
        message={_t("I accept Coursera's {tosLink} and {privacyLink}. ")}
        privacyLink={
          <a href="/about/privacy" target="_blank">
            {_t('Privacy Notice')}
          </a>
        }
        tosLink={
          <a href="/about/terms" target="_blank">
            {_t('Terms of Use')}
          </a>
        }
      />
    </p>
  </TrackedDiv>
);

export default SSO;
